import React, { useEffect, useRef, useState } from "react";
import {
  documentUploadDrive,
  getEnvelopeSenderList,
  userEnvelopeDownloadData,
  checkMyFilesEnabled
} from "../../../../services/CommonService";
import { useNavigate } from "react-router-dom";
import Utils from "../../../../utils";
import Pagination from "react-js-pagination";
import DeleteEnvelope from "./DeleteEnvelope";
import TransferEnvelope from "./TransferEnvelope";
import CopyEnvelope from "./CopyEnvelope";
import { toast } from "react-toastify";
import AddEnvelopeTemplate from "./AddEnvelopeTemplate";
import DownloadDataDoc from "./ViewEnvelope/DownloadDataDoc";
import useDocumentCounts from "./useDocumentCounts";
import Dropdown from 'rc-dropdown';
import Menu, { Item as MenuItem } from 'rc-menu';
import "../../../../assets/ManageSleeve.css";

const lengths = Utils.tableShowLengths();

// Helper function to highlight search terms
const highlightSearchTerm = (text, searchTerm) => {
  if (!searchTerm || !text) return text;

  const regex = new RegExp(`(${searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
  const parts = text.split(regex);

  return parts.map((part, index) =>
    regex.test(part) ? (
      <mark key={index} className="search-highlight" style={{
        backgroundColor: '#ffeb3b',
        padding: '0 2px',
        borderRadius: '2px',
        fontWeight: 'bold'
      }}>
        {part}
      </mark>
    ) : part
  );
};

function CompletedManageEnvelope() {
  const navigate = useNavigate();
  const userData = Utils.loginUserData();
  const userEmail = userData?.email || "";
  const [myFilesEnabled, setMyFilesEnabled] = useState(null);

  const [senderList, setSenderList] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState(null); // selectedUserId add kiya
  const [totalData, setTotalData] = useState(0);
  const [downloadDataList, setDownloadDataList] = useState({});
  const [dataParams, setDataParams] = useState({
    limit: lengths[0],
    page: 1,
    status_id: 2,
    search: "",
    sender_id: "",
    envelope_id: "",
    order_column: 'created_at',
    order_by: false,
    is_effect: false,
  });
  const [deleteEnvelope, setDeleteEnvelope] = useState({ id: 0, name: '' });
  const [selectedEnvelope, setSelectedEnvelope] = useState(null);
  const [copyEnvelope, setCopyEnvelope] = useState(0);
  const [showCloudModal, setShowCloudModal] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(null);
  const [expandedRecipients, setExpandedRecipients] = useState({});

  const DownloadDataModelRef = useRef(null);

  // Hook ka use karte hue sare required values fetch karein
  const {
    counts: { totalFiles, totalInProgress, totalDraft, totalCompleted },
    envelopeList,
    envelopeProcess,
    loading,
    setLoading,
  } = useDocumentCounts({ userEmail, selectedUserId, dataParams, userId: selectedUserId });

  useEffect(() => {
    setTotalData(totalCompleted);
  }, [totalCompleted])

  useEffect(() => {
    getEnvelopeSenderList()
      .then(response => {
        const senderData = response.data.data;
        setSenderList(senderData);
        if (senderData.length > 0) {
          setSelectedUserId(senderData[0].id);
        }
      })
      .catch(err => {
        console.error("Error fetching sender list:", err);
      });
    // Check MyFiles enabled status
    checkMyFilesEnabled({})
      .then(res => {
        if (res.data && typeof res.data.data?.myfiles_enabled !== 'undefined') {
          setMyFilesEnabled(res.data.data.myfiles_enabled);
        } else {
          setMyFilesEnabled(false);
        }
      })
      .catch(err => {
        setMyFilesEnabled(false);
      });
  }, []);

  const handleData = (e, type) => {
    let params = { ...dataParams };
    if (type === 'pagination') {
      params.page = e;
    } else if (type === 'sender') {
      params.sender_id = e.target.value;
      setSelectedUserId(e.target.value);
    } else if (type === 'envelope') {
      params.envelope_id = e.target.value;
    } else if (type === 'search') {
      params.search = e.target.value;
    } else if (type === 'limit') {
      params.limit = parseInt(e.target.value);
    }
    setDataParams(params);
  };

  const sendToCloud = (data) => {
    setLoading(true);
    let obj = { id: data.id };
    documentUploadDrive(obj)
      .then(response => {
        setLoading(false);
        toast.success(response.data.message);
        setShowCloudModal(false);
        setDataParams({ ...dataParams });
      })
      .catch(err => {
        toast.error(Utils.getErrorMessage(err));
        setLoading(false);
        setShowCloudModal(false);
      });
  };

  const onCopyEnvelope = (data) => {
    setCopyEnvelope(data.id);
  };

  const onDeleteEnvelope = (data) => {
    setDeleteEnvelope({ id: data.id, name: data.envelope_name });
  };

  const onTransferEnvelope = (data) => {
    setDeleteEnvelope({ id: data.id, name: data.envelope_name });
  };

  const handleManageView = (data) => {
    navigate('/manage/' + data.uuid, { state: { fromCompleted: true } });
  };

  const onAddEnvelopeTemplate = (data) => {
    setDeleteEnvelope({ id: data.id, name: data.envelope_name });
  };

  const handleCreateSort = (column) => {
    let params = { ...dataParams };
    params.order_column = column;
    params.order_by = !params.order_by;
    params.page = 1;
    setDataParams(params);
  };

  const handleSendCloud = (data) => {
    if (data.is_cloud_synced) {
      setSelectedEnvelope(data);
      setShowCloudModal(true);
    } else {
      sendToCloud(data);
    }
  };

  const downloadAllFileForm = (data) => {
    setLoading(true);
    let obj = { envelope_id: parseInt(data.id) };
    userEnvelopeDownloadData(obj)
      .then(res => {
        setDownloadDataList(res.data.data);
        DownloadDataModelRef?.current.click();
        setLoading(false);
      })
      .catch(err => {
        toast.error(Utils.getErrorMessage(err));
        setLoading(false);
      });
  };

  // const handleExpired = (data) => {
  //   navigate('/manage/' + data.uuid + '/expired-document');
  // };

  // Handle dropdown toggle
  const handleDropdownToggle = (id, visible) => {
    if (visible) {
      setDropdownVisible(id);
    } else {
      setDropdownVisible(null);
    }
  };

  const toggleRecipients = (envelopeId) => {
    setExpandedRecipients(prev => ({
      ...prev,
      [envelopeId]: !prev[envelopeId]
    }));
  };

  return (
    <>
      {loading && <div className="page-loading">
        <img src="/images/loader.gif" alt="loader" />
      </div>}

      <section className="section-bg-color min-height-sleeve sleeve-spacing wrapper-sleeve">
        <div className="custom_container">
          {/* Tabs */}
          <div className="d-flex justify-content-between align-items-center flex-wrap">
            <div className="table_header_wrap">
              <div
                className="nav nav-tabs mt-0 pb-0 wrap_left flexWrap"
                id="nav-tab"
                role="tablist"
              >
                <button
                  className="nav-link mb-3"
                  onClick={() => navigate("/manage")}
                  type="button"
                  role="tab"
                  aria-selected="true"
                >
                  In Progress <span>({totalInProgress})</span>
                </button>
                <button
                  className="nav-link mb-3"
                  onClick={() => navigate("/manage/draft")}
                  type="button"
                  role="tab"
                  aria-selected="true"
                >
                  Draft <span>({totalDraft})</span>
                </button>
                <button
                  className="nav-link active mb-3"
                  type="button"
                  role="tab"
                  aria-selected="true"
                >
                  Completed <span>({totalCompleted})</span>
                </button>
                <button
                  className="nav-link mb-3 d-flex"
                  onClick={() => navigate("/manage/files")}
                  type="button"
                  role="tab"
                  aria-selected="ture"
                >
                  Sleeves Files
                </button>
                {/* My Files Button Logic */}
                {myFilesEnabled && (
                  <button className="nav-link mb-3 d-flex" onClick={(e) => navigate('/manage/my-files')}
                    type="button" role="tab" aria-selected="true" >
                    My Files
                  </button>
                )}
              </div>
            </div>

            {/* Filters */}
            <div className="filters-container ">
              <div className="search-box mb-3">
                <i className="bi bi-search"></i>
                <input
                  type="text"
                  value={dataParams.search}
                  onChange={(e) => handleData(e, 'search')}
                  placeholder="Search Sleeves"
                />
              </div>
              {/* Only show user selection dropdown when there are multiple users */}
              {senderList.length > 1 && (
                <select
                  className="filter-select mb-3"
                  value={dataParams.sender_id}
                  onChange={(e) => handleData(e, 'sender')}
                  title="Select a user to filter sleeves"
                >
                  <option value="">All Users</option>
                  {senderList.map((item, index) => (
                    <option key={index} value={item.id}>
                      {item.first_name + " " + item.last_name}
                    </option>
                  ))}
                </select>
              )}
            </div>
          </div>

          {/* Table */}
          <div className="table-container table-responsive">
            <table className="table-modern">
              <thead>
                <tr>
                  <th onClick={() => handleCreateSort('created_at')} className="created-column">
                    Created
                    <i className={`ms-1 bi ${dataParams.order_column === 'created_at' ? (dataParams.order_by ? 'bi-sort-down' : 'bi-sort-up') : 'bi-sort'}`}></i>
                  </th>
                  <th onClick={() => handleCreateSort('envelope_name')} className="sleeve-name-column">
                    Sleeves Name
                    <i className={`ms-1 bi ${dataParams.order_column === 'envelope_name' ? (dataParams.order_by ? 'bi-sort-down' : 'bi-sort-up') : 'bi-sort'}`}></i>
                  </th>
                  <th onClick={() => handleCreateSort('recipient_names')} className="recipient-column">
                    Recipients
                    <i className={`ms-1 bi ${dataParams.order_column === 'recipient_names' ? (dataParams.order_by ? 'bi-sort-down' : 'bi-sort-up') : 'bi-sort'}`}></i>
                  </th>
                  <th onClick={() => handleCreateSort('due_date')} className="due-date-column">
                    Due Date
                    <i className={`ms-1 bi ${dataParams.order_column === 'due_date' ? (dataParams.order_by ? 'bi-sort-down' : 'bi-sort-up') : 'bi-sort'}`}></i>
                  </th>
                  <th onClick={() => handleCreateSort('sender_name')}>
                    User
                    <i className={`ms-1 bi ${dataParams.order_column === 'sender_name' ? (dataParams.order_by ? 'bi-sort-down' : 'bi-sort-up') : 'bi-sort'}`}></i>
                  </th>
                  <th className="table-header-center">Download</th>
                  <th className="table-header-center cloud-sync-column">Cloud Sync</th>
                  <th className="table-header-center"><i className="bi bi-three-dots-vertical" /></th>
                </tr>
              </thead>
              <tbody>
                {envelopeList.map((item, index) => (
                  <tr key={index} className={item.is_smart_sleeve ? 'smart-sleeve-row' : ''}>
                    <td className="compact-date-cell">{item.created_at}</td>
                    <td className="sleeve-name-cell">
                      <div className="d-flex align-items-center">
                        <span
                          onClick={() => handleManageView(item)}
                          className="fw-bold text_blue cur-pointer text-truncate"
                          title={item.envelope_name}
                        >
                          {highlightSearchTerm(item.envelope_name, dataParams.search)}
                        </span>
                        {item.is_smart_sleeve && (
                          <span
                            className="smart-sleeve-badge"
                            title="Smart Sleeve"
                          >
                            <i className="bi bi-lightning-fill"></i>Smart
                          </span>
                        )}
                      </div>
                    </td>
                    <td>
                      <div className="d-flex flex-column">
                        {item.recipient_names.length > 0 && (
                          <>
                            {/* Show first recipient and toggle button inline */}
                            <div className="d-flex align-items-center gap-2 mb-1">
                              <span>
                                {highlightSearchTerm(item.recipient_names[0], dataParams.search)}
                              </span>
                              {item.recipient_names.length > 1 && (
                                <button
                                  type="button"
                                  className="btn btn-link btn-sm p-0 text-primary"
                                  onClick={() => toggleRecipients(item.id)}
                                  style={{ fontSize: '12px', textDecoration: 'none' }}
                                >
                                  {expandedRecipients[item.id] ? 'Show Less' : `Show ${item.recipient_names.length - 1} More`}
                                </button>
                              )}
                            </div>

                            {/* Show remaining recipients if expanded */}
                            {expandedRecipients[item.id] && item.recipient_names.slice(1).map((recipient, r) => (
                              <span key={r + 1} className="mb-1">
                                {highlightSearchTerm(recipient, dataParams.search)}
                              </span>
                            ))}

                          </>
                        )}
                      </div>
                    </td>
                    <td className="compact-date-cell">
                      {item.due_date ? (
                        <span className={new Date(item.due_date) < new Date() ? 'text-danger' : ''}>
                          {item.due_date}
                        </span>
                      ) : (
                        <span className="text-muted">No due date</span>
                      )}
                    </td>
                    <td>{highlightSearchTerm(item.sender_name, dataParams.search)}</td>
                    <td className="table-header-center">
                      <button
                        className="btn btn-link p-0"
                        onClick={() => downloadAllFileForm(item)}
                        title="Click to Download"
                      >
                        <i
                          className={`bi bi-cloud-arrow-down-fill fs-4 ${item.is_downloaded ? 'text-success' : 'text-muted'}`}
                        />
                      </button>
                    </td>
                    <td className="table-header-center">
                      {item.cloud_sync
                        .split(",")
                        .map(Number)
                        .some((value) => value > 0) &&
                        item.cloud_type
                          .split(",")
                          .map(Number)
                          .some((value) => value > 0) > 0 && (
                          <button
                            className="btn btn-link p-0"
                            onClick={() => handleSendCloud(item)}
                            title="Send to Cloud"
                          >
                            <i className="bi bi-cloud-arrow-up fs-4 text-primary" />
                          </button>
                        )}
                    </td>
                    <td className="table-header-center">
                      <div className="sleeve-dropdown">
                        {(() => {
                          const menu = (
                            <Menu className="custom-rc-dropdown-menu">
                              {!item.is_smart_sleeve && (
                                <MenuItem key="addTemplate" className="custom-rc-dropdown-item" onClick={() => onAddEnvelopeTemplate(item)} data-bs-toggle="modal"
                                  data-bs-target="#AddEnvelopeTemplate">
                                  <i className="bi bi-plus-circle" /> Add to Templates
                                </MenuItem>
                              )}
                              <MenuItem key="duplicate" className="custom-rc-dropdown-item" onClick={() => onCopyEnvelope(item)} data-bs-toggle="modal"
                                data-bs-target="#CopyEnvelope">
                                <i className="bi bi-files" /> Duplicate Sleeves
                              </MenuItem>
                              <MenuItem key="transfer" className="custom-rc-dropdown-item" onClick={() => onTransferEnvelope(item)} data-bs-toggle="modal"
                                data-bs-target="#transferEnvelope">
                                <i className="bi bi-arrow-left-right" /> Transfer Sleeves
                              </MenuItem>
                              <MenuItem key="delete" className="custom-rc-dropdown-item-delete custom-rc-dropdown-item" onClick={() => onDeleteEnvelope(item)} data-bs-toggle="modal"
                                data-bs-target="#DeleteEnvelope">
                                <i className="bi bi-trash" /> Delete Sleeves
                              </MenuItem>
                            </Menu>
                          );
                          return (
                            <Dropdown
                              trigger={["click"]}
                              overlay={menu}
                              animation="slide-up"
                              placement="bottomRight"
                            >
                              <button className="dots-button">
                                <i className="bi bi-three-dots-vertical"></i>
                              </button>
                            </Dropdown>
                          );
                        })()}
                      </div>
                    </td>
                  </tr>
                ))}
                {envelopeList.length === 0 && (
                  <tr>
                    <td colSpan={8}>
                      <div className="no-data">
                        <i className="bi bi-inbox"></i>
                        <p>{envelopeProcess}</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {totalData > dataParams.limit && (
            <div className="table_footer_wrap">
              <div className="d-flex align-items-center mb-4">
                <span className="me-2 text-white">Show</span>
                <select className="form-select" value={dataParams.limit} style={{ width: "80px" }}
                  onChange={(e) => handleData(e, 'limit')} aria-label="Default select example">
                  {lengths && lengths.map((item, i) => <option value={item} key={i}>{item}</option>)}
                </select>
              </div>
              <div className="pagination mb-4">
                <Pagination
                  activePage={dataParams.page}
                  itemsCountPerPage={dataParams.limit}
                  totalItemsCount={totalData}
                  pageRangeDisplayed={5}
                  onChange={(e) => handleData(e, 'pagination')}
                />
              </div>
            </div>
          )}
        </div>

        {/* Cloud Sync Confirmation Modal */}
        <div
          className={`modal fade ${showCloudModal ? 'show d-block' : ''}`}
          tabIndex="-1"
          role="dialog"
          aria-labelledby="cloudSyncModalLabel"
          aria-hidden={!showCloudModal}
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="cloudSyncModalLabel">
                  Confirm Cloud Sync
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowCloudModal(false)}
                  aria-label="Close"
                >
                  <i className="bi bi-x-circle" aria-hidden="true" />
                </button>
              </div>
              <div className="modal-body">
                <p>
                  Do you really want to send your document to the cloud? You have already sent it.
                </p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowCloudModal(false)}
                >
                  No
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => sendToCloud(selectedEnvelope)}
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
        {showCloudModal && <div className="modal-backdrop fade show"></div>}

        {/* Modals */}
        <DeleteEnvelope
          deleteEnvelope={deleteEnvelope}
          setDeleteEnvelope={setDeleteEnvelope}
          setLoading={setLoading}
          dataParams={dataParams}
          setDataParams={setDataParams}
        />

        <div
          ref={DownloadDataModelRef}
          data-bs-toggle="offcanvas"
          data-bs-target="#DownloadDataDoc"
          aria-controls="DownloadDataDoc"
        />
        <DownloadDataDoc
          setLoading={setLoading}
          downloadDataList={downloadDataList}
          setDownloadDataList={setDownloadDataList}
        />

        <AddEnvelopeTemplate
          deleteEnvelope={deleteEnvelope}
          setDeleteEnvelope={setDeleteEnvelope}
          setLoading={setLoading}
        />

        <TransferEnvelope
          deleteEnvelope={deleteEnvelope}
          setDeleteEnvelope={setDeleteEnvelope}
          senderList={senderList}
          setLoading={setLoading}
          dataParams={dataParams}
          setDataParams={setDataParams}
        />

        <CopyEnvelope
          copyEnvelope={copyEnvelope}
          setCopyEnvelope={setCopyEnvelope}
          setLoading={setLoading}
        />
      </section>
    </>
  );
}

export default CompletedManageEnvelope;